<script setup lang="ts">
import MiniRegistrationForm from '@/components/mini-registration/MiniRegistrationForm.vue'

// Check if we're in a shortcode context
const miniElement = document.getElementById('mq-vue-mini-registration')
if (miniElement) {
    console.log('🔍 MiniRegistrationView: Element data attributes:', {
    categorie: miniElement.dataset.categorie,
    cursus: miniElement.dataset.cursus,
    type: miniElement.dataset.type,
    taal: miniElement.dataset.taal,
    locaties: miniElement.dataset.locaties,
    personen: miniElement.dataset.personen
  })
}
</script>

<template>
  <div class="mini-registration-view">
    <MiniRegistrationForm />
  </div>
</template>

<style scoped>
.mini-registration-view {
  padding: 2rem;
}
</style> 